//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.TurningToolBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[0,"HolderHand",1,0],[0,"InsertShape",1,0],[0,"ProfileAngle",1,0],[1,"ProfileDepthInsertBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"ProfileDistanceExBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"ProfileDistanceEyBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"ThreadHeightDifferenceBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"ThreadHeightTheoreticalBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TipOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.ThreadToolBuilder = class extends SPLM.CAM.TurningToolBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ThreadToolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ThreadToolBuilder.InsertShapes = Object.freeze({
    "Standard" : "Standard", "Trapezoidal" : "Trapezoidal", "TriangularStandard" : "TriangularStandard", "TriangularTrapezoidal" : "TriangularTrapezoidal"});

SPLM.CAM.ThreadToolBuilder.ProfileAngles = Object.freeze({
    "Deg45" : "Deg45", "Deg55" : "Deg55", "Deg60" : "Deg60", "Deg80" : "Deg80", "Deg29" : "Deg29", "Deg30" : "Deg30"});

SPLM.CAM.ThreadToolBuilder.HolderHands = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

export default SPLM;